import { DifferenceType } from '../types'

export const bankReconciliationDifferenceTypeTKeys: Record<DifferenceType, string> = {
  overpayment: 'bankreconciliation.difference_type.overpayment',
  underpayment: 'bankreconciliation.difference_type.underpayment',
  bankFee: 'bankreconciliation.difference_type.bankFee',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  exchange_rate: 'bankreconciliation.difference_type.exchange_rate',
}

export const MAX_BULK_BANK_LINE_UPDATE_RECORDS = 100
